import { initCompaniesMarquee } from '../../components/companies-marquee.js';

// init companies companies_logos
initCompaniesMarquee();
